var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 5.505h32v20.99h-32z",
    fill: "#d80027"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.712 9.889-2.608.003-.007.004.004-.007-.797-2.583-.708 2.586-2.584-.003 2.146 1.517h.013l-.025.018-.873 2.571 2.085-1.614.004-.012.004.012 2.083 1.614-.873-2.571-.023-.018h.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.152 14.038h-.534l-.163-.527-.145.527h-.526l.438.311h.003l-.005.004-.179.525.425-.329.001-.003.001.003.426.329-.18-.525-.005-.004h.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.202 16.774-.015-.554-.282.464-.505-.155.338.426.001.001-.005.001-.312.452.496-.19.002-.003v.003l.318.44-.029-.556-.001-.002.505-.171z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.278 11.316.528-.026.003-.002-.001.004.178.521.13-.541-.002-.005.002.001.53-.001-.444-.309h-.002l.002-.002.145-.533-.401.354-.437-.307.199.513h-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.737 8.126.004.001.505-.163-.509-.161-.002.001.002-.003-.009-.554-.286.462-.504-.162.333.429.004.001-.008.003-.315.446.497-.185.002-.003v.003l.314.447-.024-.557z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/CN.c8760bf0.svg";
export { ForwardRef as ReactComponent };